import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';

const get = (key: string) => {
	if (Platform.OS === 'web') {
		return localStorage.getItem(key);
	}

	return SecureStore.getItemAsync(key);
};
const set = (key: string, value: string) => {
	if (Platform.OS === 'web') {
		return localStorage.setItem(key, value);
	}

	return SecureStore.setItemAsync(key, value);
};

const deleteItem = (key: string) => {
	if (Platform.OS === 'web') {
		return localStorage.removeItem(key);
	}

	return SecureStore.deleteItemAsync(key);
};

export { get, set, deleteItem };
